import { Input } from 'antd';
import { CalendarPickerProps, ConfigProvider } from 'antd-mobile';
import 'antd-mobile/es/global';
import enUS from 'antd-mobile/es/locales/en-US';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { BsCalendar2DateFill } from 'react-icons/bs';
import { RangeCalenderProps } from './types';
import FormItem from 'antd/es/form/FormItem';
import { StyledCalendarMobile, StyledMobileWrapper } from './mobileStyles';
import clsx from 'clsx';

export const MobileRangeCalendar = ({
    presets,
    mobileValue,
    mobileDefaultValue,
    name,
    label,
    layoutLabel = 'vertical',
    required,
    placeholder,
    allowClear = true,
    disabled = false,
    format = 'YYYY-MM-DD',
    className,
    style,
    inputMobileProps,
    onChange,
    onMobileChange,
    ...props
}: RangeCalenderProps) => {
    const [selection, setSelection] = useState<[Date, Date] | null>(
        mobileValue ?? mobileDefaultValue ?? null
    );
    const [tempSelection, setTempSelection] = useState<[Date, Date] | null>(
        selection
    );

    const [open, setOpen] = useState(false);

    const handleChangeCalendar = (val: [Date, Date] | null) => {
        setTempSelection(val);
    };

    useEffect(() => {
        const applied = mobileValue ?? mobileDefaultValue ?? null;
        setSelection(applied);
        setTempSelection(applied);
    }, [mobileValue, mobileDefaultValue]);

    useEffect(() => {
        setTempSelection(selection);
    }, [selection]);

    const handleApply = (val: [Date, Date] | null) => {
        if (val && val.length === 2) {
            setSelection(val);
            setTempSelection(val);
            onMobileChange?.(val);
            onChange?.(val);
        }
        setOpen(false);
    };

    const handleCancel = () => {
        setTempSelection(selection);
        setOpen(false);
    };
    const handleClear = () => {
        setSelection(null);
        setTempSelection(null);
        onChange?.(null);
        onMobileChange?.(null);
    };
    return (
        <FormItem
            name={name}
            layout={layoutLabel}
            label={label}
            required={required}
            className="mb-0 w-full"
        >
            <StyledMobileWrapper>
                <Input
                    size="small"
                    disabled={disabled}
                    placeholder={placeholder}
                    allowClear={allowClear}
                    onClick={() => setOpen(true)}
                    value={
                        tempSelection
                            ? `${dayjs(tempSelection[0]).format(format)} – ${dayjs(tempSelection[1]).format(format)}`
                            : ''
                    }
                    suffix={
                        <button type="button" onClick={() => setOpen(true)}>
                            <BsCalendar2DateFill size={18} />
                        </button>
                    }
                    {...inputMobileProps}
                    onChange={() => {}}
                    onClear={handleClear}
                    readOnly
                />

                <ConfigProvider locale={enUS}>
                    <StyledCalendarMobile
                        {...(props as CalendarPickerProps)}
                        selectionMode="range"
                        value={tempSelection}
                        defaultValue={selection}
                        visible={open}
                        onChange={handleChangeCalendar}
                        onConfirm={handleApply}
                        onMaskClick={handleCancel}
                        onClose={handleCancel}
                        getContainer={() =>
                            document.querySelector(
                                '.calendar-container'
                            ) as HTMLElement
                        }
                        className={clsx(
                            'calendar-container [&_.adm-button-primary]:!bg-primary [&_.adm-button-primary]:!text-on-primary',
                            className
                        )}
                        style={style}
                        confirmText="Apply"
                        allowClear
                        shouldDisableDate={(date) => {
                            return dayjs(date).isAfter(dayjs(), 'day');
                        }}
                        min={dayjs()
                            .subtract(1, 'year')
                            .startOf('month')
                            .toDate()}
                        max={dayjs().endOf('day').toDate()}
                    />
                </ConfigProvider>
            </StyledMobileWrapper>
        </FormItem>
    );
};
